// extracted by mini-css-extract-plugin
module.exports = {"wrapper__header":"l0VpJ3nIoT2Y","breadcrumbs":"_1HZ2MzJHkR4a","control":"_2K7q8Io0EKmY","buttons":"_1ezNuocej1vl"};